import React, { useEffect, useState } from "react";

const COLS = 3;
const ROWS = 2;
const TOTAL = COLS * ROWS;

const IMAGES = [
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1200",
  "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200",
  "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?w=1200",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1200",
  "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200",
  "https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=1200",
  "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=1200"
];

const JigsawMini = () => {
  const [pieces, setPieces] = useState<number[]>([]);
  const [selected, setSelected] = useState<number | null>(null);
  const [completed, setCompleted] = useState(false);
  const [image, setImage] = useState(IMAGES[0]);

  useEffect(() => {
    restart();
  }, []);

  const restart = () => {
    const arr = [...Array(TOTAL).keys()];
    arr.sort(() => Math.random() - 0.5);
    setPieces(arr);
    setSelected(null);
    setCompleted(false);
    setImage(IMAGES[Math.floor(Math.random() * IMAGES.length)]);
  };

  const handleSelect = (index: number) => {
    if (completed) return;

    if (selected === null) {
      setSelected(index);
    } else {
      const newPieces = [...pieces];
      [newPieces[selected], newPieces[index]] = [
        newPieces[index],
        newPieces[selected],
      ];
      setPieces(newPieces);
      setSelected(null);
    }
  };

  useEffect(() => {
    const solved = [...Array(TOTAL).keys()];
    setCompleted(JSON.stringify(pieces) === JSON.stringify(solved));
  }, [pieces]);

  return (
    <div className="flex flex-col items-center">

      <div
        className="grid gap-[2px] mb-4"
        style={{
          gridTemplateColumns: `repeat(${COLS}, 1fr)`,
          width: "100%",
          maxWidth: "360px",
        }}
      >
        {pieces.map((piece, index) => {
          const row = Math.floor(piece / COLS);
          const col = piece % COLS;

          return (
            <div
              key={index}
              onClick={() => handleSelect(index)}
              className={`
                aspect-[3/2]
                cursor-pointer
                transition-all duration-200
                ${selected === index ? "scale-95 ring-2 ring-orange-400" : ""}
                ${pieces[index] === index ? "" : "rounded-md"}
              `}
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: `${COLS * 100}% ${ROWS * 100}%`,
                backgroundPosition: `${(col * 100) / (COLS - 1)}% ${(row * 100) / (ROWS - 1)}%`,
                backgroundRepeat: "no-repeat",
              }}
            />
          );
        })}
      </div>

      <button
        onClick={restart}
        className="px-5 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition"
      >
        Restart
      </button>

      {completed && (
        <p className="mt-4 text-green-600 font-medium">
          Puzzle completed
        </p>
      )}
    </div>
  );
};

export default JigsawMini;